import React from 'react';
import './ClassList.css';

const ClassList = ({ 
  classes, 
  onEditClass, 
  onDeleteClass, 
  selectedDate,
  dateOptions,
  onDateChange,
  loading 
}) => {
  
  const parseLocalDateTime = (dateTimeString) => {
    if (!dateTimeString) return null;
    
    console.log('Parsing ClassList date:', dateTimeString);
    
    if (typeof dateTimeString === 'string' && dateTimeString.includes(' ')) {
      const [datePart, timePart] = dateTimeString.split(' ');
      const [year, month, day] = datePart.split('-').map(Number);
      const [hour, minute, second] = (timePart || '00:00:00').split(':').map(Number);
      
      const result = new Date(year, month - 1, day, hour, minute, second || 0);
      console.log('ClassList parsed:', result, 'Hours:', result.getHours());
      return result;
    }
    
    if (dateTimeString.includes('T') && dateTimeString.includes('Z')) {
      const utcDate = new Date(dateTimeString);
      return new Date(
        utcDate.getUTCFullYear(),
        utcDate.getUTCMonth(),
        utcDate.getUTCDate(),
        utcDate.getUTCHours(),
        utcDate.getUTCMinutes(),
        utcDate.getUTCSeconds()
      );
    }
    
    if (dateTimeString.includes('T')) {
      return new Date(dateTimeString);
    }
    
    if (dateTimeString.includes('-') && !dateTimeString.includes(' ')) {
      const [year, month, day] = dateTimeString.split('-').map(Number);
      return new Date(year, month - 1, day);
    }
    
    return new Date(dateTimeString);
  };

  const formatTime = (dateTimeString) => {
    const dateTime = parseLocalDateTime(dateTimeString);
    if (!dateTime) return '00:00';
    
    const hours = dateTime.getHours();
    const minutes = dateTime.getMinutes();
    
    console.log('ClassList formatTime - Original:', dateTimeString, 'Hours:', hours, 'Minutes:', minutes);
    
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };

  const formatDate = (dateTimeString) => {
    const dateTime = parseLocalDateTime(dateTimeString);
    if (!dateTime || isNaN(dateTime.getTime())) return 'Неизвестно';
    
    const day = String(dateTime.getDate()).padStart(2, '0');
    const month = String(dateTime.getMonth() + 1).padStart(2, '0');
    const year = dateTime.getFullYear();
    
    return `${day}.${month}.${year}`;
  };

  const formatDuration = (startTime, endTime) => {
    const start = parseLocalDateTime(startTime);
    const end = parseLocalDateTime(endTime);
    
    if (!start || !end) return '';
    
    const diffMs = end - start;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    
    if (diffMins < 60) {
      return `${diffMins}м`;
    }
    
    const hours = Math.floor(diffMins / 60);
    const minutes = diffMins % 60;
    
    return minutes > 0 ? `${hours}ч ${minutes}м` : `${hours}ч`;
  };

  const getStatusBadge = (classItem) => {
    const now = new Date();
    const startTime = parseLocalDateTime(classItem.start_time);
    const endTime = parseLocalDateTime(classItem.end_time);
    
    if (!startTime || !endTime) return 'unknown';
    
    if (now < startTime) return 'upcoming';
    if (now >= startTime && now <= endTime) return 'active';
    return 'completed';
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'upcoming': return 'Предстоит';
      case 'active': return 'Идет сейчас';
      case 'completed': return 'Завершено';
      default: return 'Неизвестно';
    }
  };

  if (loading) {
    return (
      <div className="class-list-loading">
        <div className="class-list-spinner"></div>
        <p>Загрузка занятий...</p>
      </div>
    );
  }

  if (classes.length === 0) {
    return (
      <div className="class-list-empty">
        <div className="class-list-empty-icon">📅</div>
        <h3>Нет занятий на выбранную дату</h3>
        <p>Добавьте новое занятие или выберите другую дату</p>
      </div>
    );
  }

  const sortedClasses = [...classes].sort((a, b) => {
    const timeA = parseLocalDateTime(a.start_time);
    const timeB = parseLocalDateTime(b.start_time);
    return timeA - timeB;
  });

  return (
    <div className="class-list">
      {sortedClasses.map(classItem => {
        const status = getStatusBadge(classItem);
        const occupancyPercent = Math.round(((classItem.booked || 0) / classItem.capacity) * 100);
        
        console.log('Rendering class:', classItem.class_name, 'Start:', classItem.start_time, 'Formatted:', formatTime(classItem.start_time));
        
        return (
          <div key={classItem.id} className={`class-card status-${status}`}>
            {/* Card Header */}
            <div className="class-card-header">
              <div className="class-time">
                <span className="time-start">{formatTime(classItem.start_time)}</span>
                <span className="time-sep">—</span>
                <span className="time-end">{formatTime(classItem.end_time)}</span>
                <span className="time-duration">({formatDuration(classItem.start_time, classItem.end_time)})</span>
              </div>
              <span className={`class-status-badge badge-${status}`}>
                {getStatusText(status)}
              </span>
            </div>

            {/* Card Body */}
            <div className="class-card-body">
              <h4 className="class-name">{classItem.class_name}</h4>
              
              {classItem.category && (
                <span className="class-category">{classItem.category}</span>
              )}

              <div className="class-details">
                {classItem.trainer && (
                  <div className="class-detail">
                    <span className="detail-label">Тренер</span>
                    <span className="detail-value">{classItem.trainer}</span>
                  </div>
                )}

                <div className="class-detail">
                  <span className="detail-label">Занято мест</span>
                  <span className="detail-value">
                    {classItem.booked || 0} / {classItem.capacity}
                    <span className="detail-percent">({occupancyPercent}%)</span>
                  </span>
                </div>

                <div className="class-detail">
                  <span className="detail-label">Цена</span>
                  <span className="detail-value detail-price">{parseFloat(classItem.price).toFixed(0)} ₽</span>
                </div>
              </div>

              {classItem.description && (
                <div className="class-description">
                  <p>{classItem.description}</p>
                </div>
              )}

              {/* Occupancy Bar */}
              <div className="class-occupancy">
                <div 
                  className="class-occupancy-fill"
                  style={{ width: `${occupancyPercent}%` }}
                />
              </div>
            </div>

            {/* Card Actions */}
            <div className="class-card-actions">
              <button 
                className="class-btn class-btn-edit"
                onClick={() => onEditClass && onEditClass(classItem)}
                title="Редактировать"
              >
                ✎
              </button>
              <button 
                className="class-btn class-btn-delete"
                onClick={() => onDeleteClass && onDeleteClass(classItem.id)}
                title="Удалить"
              >
                ✕
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClassList;
